export const workingHoursHeader = [
  { header: "Date" },
  { header: "Shift" },
  { header: "Check-In" },
  { header: "Check-Out" },
  { header: "Break" },
  { header: "Shift Hours" },
  { header: "Over Time Hours" },
  { header: "Total Working hours" },
  { header: "Leave Credit Hours" },
  { header: "Status" },
];

export const firstLevelWorkingHours = [
  { header: "Employee Name", key: "employee_name" },
  { header: "Employee Id", key: "employee_id" },
  { header: "Assigned Shift", key: "assigned_shift" },
  { header: "Week Off", key: "week_off_count" },
  { header: "Holiday", key: "holiday_count" },
  { header: "Leave", key: "leave_count" },
  { header: "Absent", key: "absent_count" },
  { header: "Present", key: "present_count" },
  { header: "Permission", key: "no_of_permission" },
  { header: "Late", key: "no_of_late" },
  { header: "Total Working Hours", key: "total_working_hours" },
  { header: "Shift Working Hours", key: "shift_working_hours" },
  { header: "Over Time Hours", key: "ot_hours" },
  { header: "Total Break Hours", key: "total_break_hours" },
];
